/**
 * localStorage for preferences, without the throws. With Safari's "Block All
 * Cookies" on, just touching localStorage throws, and a throw while the app
 * frame renders (a useState initializer in a layout or context) takes every
 * page down. These fall back to "nothing saved" and keep a value for this
 * visit only. (Drafts that must survive have their own helper: localDraft.js.)
 */
export const readPref = (key) => {
  try { return localStorage.getItem(key); } catch { return null; }
};

export const readJsonPref = (key, fallback) => {
  try {
    const saved = readPref(key);
    return saved ? JSON.parse(saved) : fallback;
  } catch {
    return fallback;
  }
};

export const writePref = (key, value) => {
  try { localStorage.setItem(key, value); } catch { /* storage unavailable: kept for this visit only */ }
};

export const removePref = (key) => {
  try { localStorage.removeItem(key); } catch { /* storage unavailable */ }
};
